import * as React from 'react';
import { setLogLevel } from 'livekit-client';
import { useRoomContext } from '@livekit/components-react';
const IS_DEV = process.env.NODE_ENV === 'development';
export const useDebugMode = ({ logLevel } = {}) => {
    const room = useRoomContext();
    React.useEffect(() => {
        if (!IS_DEV)
            return;
        setLogLevel(logLevel !== null && logLevel !== void 0 ? logLevel : 'debug');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.__lk_room = room;
        return () => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.__lk_room = undefined;
        };
    }, [room, logLevel]);
};
